import { Card, Checkbox, Col, DatePicker, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { FiUpload } from "react-icons/fi";
import FormAction from "../../../../components/common/FormAction";

import "./LeaseInformation.css";

function LeaseInformation({ data }) {
  const [checked, setChecked] = useState(false);
  const [monthToMonth, setMonthToMonth] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    console.log(values);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const leaseInfo = {
      "leaseInformation.signedDate": values.signedOn
        ? values.signedOn.format("YYYY-MM-DD")
        : data?.leaseInformation?.signedDate,
      "leaseInformation.momthToMonth": values.monthToMonth,
      "leaseInformation.startDate": values.startDate
        ? values.startDate.format("YYYY-MM-DD")
        : data?.leaseInformation?.startDate,

      "leaseInformation.endDate": values.endDate
        ? values.endDate.format("YYYY-MM-DD")
        : data?.leaseInformation?.endDate,
      "leaseInformation.renewelDate": values.renewelDate
        ? values.renewelDate.format("YYYY-MM-DD")
        : data?.leaseInformation?.renewelDate,
      "leaseInformation.insuranceRequirement": values.insuranceRequirement,
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, leaseInfo);
      setChecked(false);
      toast.success("Tenant lease info updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    monthToMonth: data?.leaseInformation?.monthToMonth,
    insuranceRequirement: data?.leaseInformation?.insuranceRequirement,
  };
  return (
    <Row className="lease-information">
      <Col span={24}>
        <Card
          title="Lease Information"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  labelWrap={{ span: 8 }}
                  initialValues={initialValues}
                  onFinish={handleFormSubmit}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item label="Signed On" name="signedOn">
                    <DatePicker />
                  </Form.Item>
                  <Form.Item
                    label=" "
                    name="monthToMonth"
                    valuePropName="checked"
                  >
                    <Checkbox
                      checked={data?.leaseDetails?.leaseDates?.monthToMonth}
                      onChange={() => setMonthToMonth(!monthToMonth)}
                    >
                      Month To Month
                    </Checkbox>
                  </Form.Item>
                  <Form.Item label="Start Date" name="startDate">
                    <DatePicker />
                  </Form.Item>
                  {!monthToMonth && (
                    <Form.Item label="End Date" name="endDate">
                      <DatePicker />
                    </Form.Item>
                  )}
                  <Form.Item label="Renewed On" name="renewelDate">
                    <DatePicker />
                  </Form.Item>
                  <Form.Item
                    label="Insurance Requirement"
                    name="insuranceRequirement"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      This lease requires the tenant to demonstrate proof of
                      liability insurance for at least $100,000.
                    </Checkbox>
                  </Form.Item>
                  <FormAction submit="submit" cancel={onCancel} />
                </Form>
              </Col>
            </Row>
          ) : (
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  labelWrap={{ span: 8 }}
                >
                  <Form.Item label="Lease Signed">
                    <p>
                      {data?.leaseInformation?.signedDate
                        ? data?.leaseInformation?.signedDate
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Month To Month">
                    <p>{data?.leaseInformation?.monthToMonth ? "Yes" : "No"}</p>
                  </Form.Item>
                  <Form.Item label="Lease From">
                    <p>
                      {" "}
                      {data?.leaseInformation?.startDate
                        ? data?.leaseInformation?.startDate
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Lease To">
                    <p>
                      {data?.leaseInformation?.endDate
                        ? data?.leaseInformation?.endDate
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Last Lease Renewal">
                    <p>
                      {data?.leaseInformation?.renewelDate
                        ? data?.leaseInformation?.renewelDate
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="Insurance Requirement">
                    <p>
                      {data?.leaseInformation?.insuranceRequirement
                        ? "Yes"
                        : "No"}
                    </p>
                  </Form.Item>
                </Form>
              </Col>
              <Col span={24}>
                <strong>Lease Documents</strong>
              </Col>
              <Col span={24}>
                <Row className="header-row">
                  <Col span={10}>
                    <span>Document</span>
                  </Col>
                  <Col span={5}>
                    <span>Lease Dates</span>
                  </Col>
                  <Col span={4}>
                    <span>Status</span>
                  </Col>
                  <Col span={5}>
                    <span>Action</span>
                  </Col>
                </Row>
                {data?.leaseDocuments
                  ? data.leaseDocuments.map((item, index) => {
                      return (
                        <Row className="data-row" key={index}>
                          <Col span={10}>
                            <span className="onclick-text">
                              {item.document}
                            </span>
                          </Col>
                          <Col span={5}>
                            <span>{item.leaseDates}</span>
                          </Col>
                          <Col span={4}>
                            <span>{item.Status}</span>
                          </Col>
                          <Col span={5}>
                            <p className="onclick-text">
                              <FiUpload size={18} />
                              <span style={{ marginLeft: "8px" }}>
                                View In Browser
                              </span>
                            </p>
                          </Col>
                        </Row>
                      );
                    })
                  : null}
              </Col>
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default LeaseInformation;
